/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Office_Logo_MissingInputs */

const cs_draft_office_logo_missing = /** @type {(inputs: Draft_Office_Logo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo kanceláře ještě není nahrané. Katalogy ho vynechají, dokud ho nepřidáte.`)
};

const en_draft_office_logo_missing = /** @type {(inputs: Draft_Office_Logo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No office logo uploaded yet. Catalogs will omit it until you add one.`)
};

/**
* | output |
* | --- |
* | "No office logo uploaded yet. Catalogs will omit it until you add one." |
*
* @param {Draft_Office_Logo_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_office_logo_missing = /** @type {((inputs?: Draft_Office_Logo_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Office_Logo_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_office_logo_missing(inputs)
	return cs_draft_office_logo_missing(inputs)
});